import { type GenericLayout, LayoutType } from "@mm/metx-workbench.meteomatics.com";
import type { ComponentSwitchMapping } from "../../CommonParts/ComponentSwitcher";
import { CountryPlotForm } from "./CountryPlotForm/view";
import { NoteForm } from "./NoteForm/view";

export type ToolFormUpdateControllerProp = {
  layout: GenericLayout;
};

/**
 * A mapping describing which layer uses which form controller.
 * Used by component switcher
 */
export const toolFormControllerMapping: ComponentSwitchMapping<ToolFormUpdateControllerProp, any> = {
  resolvePropsToComponentId: (props) => (props.layout.type as any) ?? "",
  componentsById: {
    // Note: We can safely cast the props type here as this is guaranteeded
    // if the ComponentSwitcher is working properly.
    // TODO Replace with actual layout type from bindings
    [LayoutType.CountryPlot]: (props) =>
      props.layout.id_tool ? <CountryPlotForm toolId={props.layout.id_tool} /> : null,
    [LayoutType.Notes]: (props) => (props.layout.id_tool ? <NoteForm toolId={props.layout.id_tool} /> : null),
  },
};
